<template>
  <div
    id="conversation-tab-v2"
    v-if="isExpand"
    class="right-side">
    <MessageSearchBoxV2
      v-if="isSearching"
      :searchId="searchId"
      :searchMessageData="searchMessageData"
      @onSelectMessage="e=> $emit('onSelectMessage', e)"
      @updateSearchDateRange="(e) => $emit('updateSearchDateRange', e)"
      @closeSearching="$emit('closeSearching')" />
    <div v-else>
      <div class="z2-conversation-header border-bottom">
        <div
          class="radio-button"
          :class="infoTab === 'info' && 'radio-button-active'"
          @click="infoTab = 'info'">
          <span>Thông tin</span>
        </div>
        <div
          class="radio-button"
          :class="infoTab === 'order' && 'radio-button-active'"
          @click="infoTab = 'order'">
          <span>Đơn hàng</span>
        </div>
        <div
          v-if="!conversation.group"
          class="radio-button"
          :class="infoTab === 'note' && 'radio-button-active'"
          @click="infoTab = 'note'">
          <span>Ghi chú</span>
        </div>
      </div>

      <ConversationTabInfoV2
        v-if="infoTab === 'info'"
        :conversation="conversation"
        :messageMedia="messageMedia"
        :messageFile="messageFile"
        :messageLink="messageLink"
        :profile="profile"
        :members="members"
        :pendingMems="pendingMems"
        :isCanDeleteGroup="isCanDeleteGroup"
        :isRemove="isRemove"
        @getGroupInfo="(conv) => $emit('getGroupInfo', conv)"
        @showMenu="showMenu" />

      <CreateOrder
        v-if="infoTab === 'order'"
        :conversation="conversation"
        class="py-1" />

      <div v-if="infoTab === 'note'">
        <CustomerInfo
          v-if="!conversation.group"
          :conversation="conversation" />
        <MemberTab
          v-else
          :conversation="conversation" />
      </div>

      <MenuMessageTab
        v-show="isMenuVisible"
        :conversation="conversation"
        :message="menuMessage"
        :isShowFull="isShowFull"
        @hideMenu="isMenuVisible = false" />
    </div>
  </div>
</template>

<script>
import ConversationTabInfoV2 from "./ConversationTabInfoV2.vue";
import MenuMessageTab from "./Popup/MenuMessageTab.vue";
import MemberTab from "./InformationConversation/MemberTab";
import CustomerInfo from "./CustomerInfo";
import CreateOrder from "./InformationConversation/CreateOrder";
import MessageSearchBoxV2 from "./MessageSearchBoxV2.vue";

export default {
  props: [
    "conversation",
    "isExpand",
    "isSearching",
    "messageMedia",
    "messageFile",
    "messageLink",
    "profile",
    "members",
    "pendingMems",
    "isCanDeleteGroup",
    "isRemove",
    "searchMessageData",
    "searchId"
  ],
  components: {
    ConversationTabInfoV2,
    MenuMessageTab,
    MemberTab,
    CustomerInfo,
    CreateOrder,
    MessageSearchBoxV2,
  },
  data() {
    return {
      infoTab: "info",
      isMenuVisible: false,
      menuMessage: {},
      isShowFull: false,
    };
  },
  computed: {},
  methods: {
    showMenu(e, message, isShowFull) {
      this.isMenuVisible = true;
      this.menuMessage = message;
      this.isShowFull = isShowFull ? true : false;
      this.setPosition(e);
    },
    setPosition(event) {
      const menu = document.getElementById("context-menu-message");
      if (window.innerWidth - event.clientX < 118) {
        menu.style.left = `${event.clientX - 100}px`;
      } else {
        menu.style.left = `${event.clientX}px`;
      }
      if (window.innerHeight - event.clientY < 165) {
        menu.style.top = `${event.clientY - 165}px`;
      } else {
        menu.style.top = `${event.clientY + 12}px`;
      }
    },
  },
  created() {
    this.$bus.$on("selectConversationV2", (conversation) => {
      if (conversation.group && this.infoTab === "note") {
        this.infoTab = "info";
      }
    });
  },
  mounted() {
    window.addEventListener("click", () => {
      this.isMenuVisible = false;
    });
  },
};
</script>

<style lang="scss" >
.right-side {
  min-width: 300px;
  max-width: 300px;
}

.radio-button {
  background-color: white;
  max-height: 36px;
  min-height: 36px;
  margin: 0 0.25rem 5px 0.25rem;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}
.radio-button:hover {
  background-color: rgb(233, 239, 248);
  color: rgba(10, 88, 192, 1);
}
.radio-button-active {
  font-weight: 600;
  background-color: rgba(225, 237, 253, 1);
  color: rgba(10, 88, 192, 1);
}
</style>